import { useCallback, useEffect, useRef, useState } from "react";
import { useLoadScript } from "@react-google-maps/api";

// On peut taper la signature qu'on veut renvoyer.
// Pour simuler Axios, on renvoie Promise<PseudoAxiosResponse>.
type TGoogleResponse = {
  data: { predictions: google.maps.places.AutocompletePrediction[] };
  status?: number;
  [key: string]: any;
};

export function useGooglePlacesAutocomplete() {
  // 1. Charger la librairie "places" via useLoadScript
  const { url, isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyD4TOLtrIWjl8cuINiTCBD0eI0VRrVLUHg",
    libraries: ["places"],
  });

  console.log(url, isLoaded, loadError);

  // 2. Stocker une ref vers AutocompleteService
  const autocompleteServiceRef =
    useRef<google.maps.places.AutocompleteService | null>(null);

  // 3. Initialiser le service quand c’est prêt
  useEffect(() => {
    if (isLoaded && !autocompleteServiceRef.current) {
      autocompleteServiceRef.current =
        new google.maps.places.AutocompleteService();
    }
  }, [isLoaded]);

  // 4. Créer une fonction "apiGetCitiesByCountry" qui retourne une Promesse
  const apiGetCitiesByCountryfromHook = useCallback(
    (country: string, cityPrefix: string): Promise<TGoogleResponse> => {
      // On renvoie immédiatement une promesse
      return new Promise((resolve, reject) => {
        // a) Vérifs basiques
        if (loadError) {
          return reject({
            response: {
              data: {
                message: "Impossible de charger la librairie Google Maps",
              },
            },
          });
        }
        console.log("a");
        if (!isLoaded) {
          return reject({
            response: {
              data: { message: "Librairie Google Maps pas encore chargée" },
            },
          });
        }
        console.log("b");
        if (!country?.trim() || !cityPrefix?.trim()) {
          // S'il n'y a pas de pays ou de préfixe, on ne fait rien
          return resolve({ data: { predictions: [] }, status: 200 });
        }
        console.log("c");
        if (!autocompleteServiceRef.current) {
          return reject({
            response: {
              data: { message: "AutocompleteService n'est pas initialisé" },
            },
          });
        }

        // b) Construire la requête
        const request: google.maps.places.AutocompletionRequest = {
          input: cityPrefix,
          types: ["(cities)"],
          componentRestrictions: { country },
          language: "fr",
        };

        // c) Appeler AutocompleteService
        autocompleteServiceRef.current.getPlacePredictions(
          request,
          (predictions, status) => {
            if (
              status === google.maps.places.PlacesServiceStatus.OK &&
              predictions
            ) {
              console.log(predictions);
              // On fabrique un "pseudo" objet AxiosResponse
              const response = {
                data: { predictions },
                status: 200,
                statusText: "OK",
                headers: {},
                config: {},
              };
              resolve(response);
            } else {
              // En cas de problème (ZERO_RESULTS, OVER_QUERY_LIMIT, etc.)
              reject({
                response: {
                  data: { message: `Google Places status: ${status}` },
                  status,
                },
              });
            }
          }
        );
      });
    },
    [isLoaded, loadError]
  );

  // 5. Renvoyer la fonction et l’état de chargement
  return {
    apiGetCitiesByCountryfromHook,
    isLoaded,
    loadError,
  };
}
